import styled from '@emotion/styled';
import * as React from 'react';

export enum TagBadgeTone {
  DEFAULT = 'default',
  MUTED = 'muted',
  NEW = 'new'
}

export type TagBadgeToneLike = TagBadgeTone | (string & {});

export interface TagBadgeWidgetProps {
  children?: React.ReactNode;
  className?: string;
  label?: string;
  sinceVersion?: string;
  tone?: TagBadgeToneLike;
}

export const TagBadgeWidget: React.FC<TagBadgeWidgetProps> = (props) => {
  const label = props.label ?? props.children;
  const isNewTag = typeof label === 'string' && label.trim().toLowerCase().startsWith('new');
  const resolvedTone = resolveTone(props.tone, isNewTag);
  const title = props.sinceVersion ? `New since ${props.sinceVersion}` : undefined;

  return (
    <S.Tag
      className={props.className}
      data-since-version={props.sinceVersion}
      data-tag-badge="true"
      title={title}
      $tone={resolvedTone}
    >
      {label}
    </S.Tag>
  );
};

const resolveTone = (tone?: TagBadgeToneLike, isNewTag = false): TagBadgeTone => {
  switch (tone) {
    case TagBadgeTone.MUTED:
      return TagBadgeTone.MUTED;
    case TagBadgeTone.NEW:
      return TagBadgeTone.NEW;
    case TagBadgeTone.DEFAULT:
      return TagBadgeTone.DEFAULT;
    default:
      return isNewTag ? TagBadgeTone.NEW : TagBadgeTone.DEFAULT;
  }
};

namespace S {
  export const Tag = styled.span<{ $tone: TagBadgeTone }>`
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    background: ${(p) => p.theme.tagBadge[p.$tone].background};
    color: ${(p) => p.theme.tagBadge[p.$tone].color};
    border: 1px solid ${(p) => p.theme.tagBadge[p.$tone].border};
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    line-height: 1.2;
    text-transform: uppercase;
  `;
}
